import {
  postRequest,
  getRequest,
  putRequest
} from '../http-v2/index.js';

export const fetchCronofyLinkForSpace = async (spaceId) => {
  return postRequest({
    endpoint: '/web-hosting/cronofy/csrf/token',
    body: {
      space_id: spaceId
    }
  });
};

export const fetchSyncDataForSpace = async (spaceId) => {
  return getRequest({
    endpoint: '/v1/calendar/cronofy/space/:spaceId/calendar/settings',
    params: { spaceId },
    options: {
      useAccessToken: true
    }
  });
};

export const fetchCronofyCalendars = async (spaceId) => {
  return getRequest({
    endpoint: '/v1/calendar/cronofy/space/:spaceId/calendars',
    params: { spaceId },
    options: {
      useAccessToken: true
    }
  });
};

export const connectCalendar = async (spaceId, calendarId) => {
  return putRequest({
    endpoint: '/v1/calendar/cronofy/space/:spaceId/calendar/:calendarId/connect',
    params: {
      spaceId,
      calendarId
    },
    options: {
      useAccessToken: true
    }
  });
};

export const resyncCalendar = async (spaceId) => {
  return putRequest({
    endpoint: '/v1/calendar/cronofy/space/:spaceId/calendar/resync',
    params: {
      spaceId
    },
    options: {
      useAccessToken: true
    }
  });
};

export const disconnectCalendar = async (spaceId) => {
  return putRequest({
    endpoint: '/v1/calendar/cronofy/space/:spaceId/calendar/disconnect',
    params: {
      spaceId
    },
    options: {
      useAccessToken: true
    }
  });
};

export const authorizeIcsCalendarImport = async (spaceId, importUrl, calendarName) => {
  return postRequest({
    endpoint: '/v1/calendar/cronofy/space/:spaceId/ics/authorize',
    params: {
      spaceId
    },
    body: {
      source_url: importUrl,
      calendar_name: calendarName
    },
    options: {
      useAccessToken: true
    }
  });
};

// All exports are now named exports above
